// extracted by mini-css-extract-plugin
export default {"editPopupContainer":"EditPage_editPopupContainer__mgHeH","popIn":"EditPage_popIn__AeJsh"};